<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: '未付款统计',
				modal_width:1000,
				modal_height:600,
				list_footerField:[
					{field:'needamount',toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = [{
						field: 'scoresupplierid',
						title: '供应商',
					},
					{
						field: 'deductoption',
						title: '扣分类别'
					},
					{
						field: 'deductscore',
						title: '扣分分值',
					},
					{
						field: 'mark',
						title: '原因',
					},
					{
						field: 'file_img',
						title: '凭证',
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					let data = []
					this.$api.supplierscore.list().then(()=>{
						
					})
					
					// let groupdata = this.$Lodash.groupBy(this.data, 'bankAcc')
					// for(let i in groupdata){
					// 	let obj = {}
					// 	obj.id = groupdata[i][0].id
					// 	obj.bankAcc = i
					// 	obj.accName = groupdata[i][0].accName
					// 	obj.needamount = this.$Lodash.sumBy(groupdata[i], item=>parseFloat(item.needamount))
					// 	obj.needamount = obj.needamount.toFixed(2)
					// 	data.push(obj)
					// }
					console.log(data)
					resolve({
						list: data
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>